import { OAuth2Client } from '@kolorado/oauth';
import { axiosInstance } from "../axios-instance";

class SwitchConfiguration {
    private authClient: OAuth2Client | null;

    private baseUrlV2: string;

    constructor(authClient: OAuth2Client | null, baseUrlV2: string) {
        this.authClient = authClient;
        this.baseUrlV2 = baseUrlV2;
    }

    getSwitchConfigurationForAsset(
        queryParameters: any
    ): Promise<any> {
        const accessToken = localStorage.getItem('accessToken');
        return axiosInstance.get<any>(`${this.baseUrlV2}/configStatuses`, {
            params: queryParameters,
            headers: {
                Authorization: `Bearer ${accessToken}`,
            }
        }).catch((error) => {
            throw new Error(error);
        });
    }
}
export default SwitchConfiguration;